
import { formatPrice } from '@/utils/helpers'
import analytics from '@/mixins.js/analytics'

export default {
  filters: { formatPrice },
  mixins: [analytics],
  props: {
    diagram: { type: Object, required: true },
    listName: { type: String, required: true },
    listPosition: { type: Number, required: true },
    showAddCart: { type: Boolean, default: true }
  },
  computed: {
    image () {
      return this.diagram.image.full_size
    }
  }
}
